export default __webpack_public_path__ + "static/terminal_statuslight_highlight-b84f0bb49a60851baa1f2cf80edacd1c.png";